import * as tslib_1 from "tslib";
import { ShadingMethodBase } from "./ShadingMethodBase";
/**
 * EffectAlphaMaskMethod allows the use of an additional texture to specify the alpha value of the material. When used
 * with the secondary uv set, it allows for a tiled main texture with independently varying alpha (useful for water
 * etc).
 */
var EffectAlphaMaskMethod = (function (_super) {
    tslib_1.__extends(EffectAlphaMaskMethod, _super);
    /**
     * Creates a new EffectAlphaMaskMethod object.
     *
     * @param texture The texture to use as the alpha mask.
     * @param useSecondaryUV Indicated whether or not the secondary uv set for the mask. This allows mapping alpha independently.
     */
    function EffectAlphaMaskMethod(texture, useSecondaryUV) {
        if (useSecondaryUV === void 0) { useSecondaryUV = false; }
        var _this = _super.call(this) || this;
        _this._texture = texture;
        _this._useSecondaryUV = useSecondaryUV;
        if (_this._texture)
            _this.iAddTexture(_this._texture);
        return _this;
    }
    Object.defineProperty(EffectAlphaMaskMethod.prototype, "assetType", {
        /**
         * @inheritDoc
         */
        get: function () {
            return EffectAlphaMaskMethod.assetType;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EffectAlphaMaskMethod.prototype, "texture", {
        /**
         * The texture to use as the alpha mask.
         */
        get: function () {
            return this._texture;
        },
        set: function (value) {
            if (this._texture == value)
                return;
            if (this._texture)
                this.iRemoveTexture(this._texture);
            this._texture = value;
            if (this._texture)
                this.iAddTexture(this._texture);
            this.invalidateShaderProgram();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EffectAlphaMaskMethod.prototype, "useSecondaryUV", {
        /**
         * Indicated whether or not the secondary uv set for the mask. This allows mapping alpha independently, for
         * instance to tile the main texture and normal map while providing untiled alpha, for example to define the
         * transparency over a tiled water surface.
         */
        get: function () {
            return this._useSecondaryUV;
        },
        set: function (value) {
            if (this._useSecondaryUV == value)
                return;
            this._useSecondaryUV = value;
            this.invalidateShaderProgram();
        },
        enumerable: true,
        configurable: true
    });
    return EffectAlphaMaskMethod;
}(ShadingMethodBase));
export { EffectAlphaMaskMethod };
EffectAlphaMaskMethod.assetType = "[asset EffectAlphaMaskMethod]";



// WEBPACK FOOTER //
// ../dist/lib/methods/EffectAlphaMaskMethod.js